import { FC, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { Row, Col, CardBody, CardTitle, CardSubtitle, Card, Label } from "reactstrap";
import Block from "../../components/Block.component";
import DeviceConfig from "../../config/Device.config";
import UsuarioModel from "../../models/Usuario.model";
import Swal from "sweetalert2";
import colors from "../../config/Colors.config";
import Cookies from 'universal-cookie';
import Tiempo from "../../tools/Tiempo.tool";
import imgREUNE from "../../assets/imgs/REUNE.png";
import { Dashboard, Logout } from "@mui/icons-material";

const cookies = new Cookies();

const PanelReune: FC = () => {

    const [device, setDevice] = useState(DeviceConfig.getData());

    useEffect(() => {
        cargarDatos();
        validarToken();
    }, []);

    const cargarDatos = (): void => {
        setDevice(DeviceConfig.getData());
    }

    const validarToken = (): void => {
        const token: string = UsuarioModel.getToken();
        if (token.length === 0) {
            document.body.innerHTML = "<body></body>";
            Swal.fire({
                icon: "warning",
                title: "Acceso Denegado",
                text: `Debes iniciar sesión para poder usar el sistema`,
                showConfirmButton: true,
                confirmButtonColor: colors.dorado01,
                confirmButtonText: "Ok",
                timerProgressBar: true,
                reverseButtons: true,
                timer: 10000
            }).then(async (response) => {
                if (response.isConfirmed) {
                    cookies.remove("usuario");
                    Tiempo.sleep(0.5).then(() => window.location.href = "/");
                }
            });
            Tiempo.sleep(10).then(() => window.location.href = "/");
        }
    }

    return (
        <section style={{ width: "100%", height: "100vh" }} >
            <ToastContainer limit={3} position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
            <Block height={70} />

            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5 }} >
                <Col style={{ textAlign: "left" }} >
                    <Dashboard style={{ marginRight: 10, color: colors.dorado01 }} />
                    <Label
                        style={{ color: colors.dorado01, textDecorationLine: "underline", fontSize: 18, cursor: "pointer" }}
                        onClick={() => {
                            window.location.href = "/dashboard";
                        }}
                    >
                        Ir al Dashboard
                    </Label>
                </Col>
                <Col style={{ textAlign: "right" }} >
                    <Logout style={{ marginRight: 10, color: colors.dorado01 }} />
                    <Label
                        style={{ color: colors.dorado01, textDecorationLine: "underline", fontSize: 18, cursor: "pointer" }}
                        onClick={() => {
                            Swal.fire({
                                icon: "question",
                                title: "Salir del Sistema",
                                text: `¿Estas seguro de que quieres salir del sistema?`,
                                showConfirmButton: true,
                                confirmButtonColor: colors.dorado01,
                                showCancelButton: true,
                                cancelButtonText: "No",
                                confirmButtonText: "Si",
                                timerProgressBar: true,
                                reverseButtons: true,
                                timer: 10000
                            }).then(async (response) => {
                                if (response.isConfirmed) {
                                    cookies.remove("usuario");
                                    Tiempo.sleep(0.5).then(() => window.location.href = "/");
                                }
                            });
                        }}
                    >
                        Salir del Sistema
                    </Label>
                </Col>
            </Row>

            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5, marginTop:100 }} >
                <Col>
                    <Card
                        style={{ width: '18rem', borderRadius: 12, height: 300, marginLeft: 50, cursor: "pointer" }}
                        onClick={() => {
                            window.location.href = "/reune/panel/consultas"
                        }}
                    >
                        <center>
                            <img
                                alt="Sample"
                                src={imgREUNE}
                                style={{ marginTop: 30, marginRight: 0, marginLeft: 0 }}
                            />
                        </center>
                        <CardBody>
                            <CardTitle tag="h3" style={{ textAlign: "center" }}>
                                Consultas
                            </CardTitle>
                            <CardSubtitle
                                className="mb-2 text-muted"
                                tag="h5"
                                style={{ textAlign: "center" }}
                            >
                                REUNE
                            </CardSubtitle>
                        </CardBody>
                    </Card>
                </Col>
                <Col>
                    <Card
                        style={{ width: '18rem', borderRadius: 12, height: 300, marginLeft: 50, cursor: "pointer" }}
                        onClick={() => {
                            window.location.href = "/reune/panel/reclamaciones"
                        }}
                    >
                        <center>
                            <img
                                alt="Sample"
                                src={imgREUNE}
                                style={{ marginTop: 30, marginRight: 0, marginLeft: 0 }}
                            />
                        </center>
                        <CardBody>
                            <CardTitle tag="h3" style={{ textAlign: "center" }}>
                                Reclamaciones
                            </CardTitle>
                            <CardSubtitle
                                className="mb-2 text-muted"
                                tag="h5"
                                style={{ textAlign: "center" }}
                            >
                                REUNE
                            </CardSubtitle>
                        </CardBody>
                    </Card>
                </Col>
                <Col>
                    <Card
                        style={{ width: '18rem', borderRadius: 12, height: 300, marginLeft: 50, cursor: "pointer" }}
                        onClick={() => {    
                            window.location.href = "/reune/panel/aclaraciones"
                        }}
                    >
                        <center>
                            <img
                                alt="Sample"
                                src={imgREUNE}
                                style={{ marginTop: 30, marginRight: 0, marginLeft: 0 }}
                            />
                        </center>
                        <CardBody>
                            <CardTitle tag="h3" style={{ textAlign: "center" }}>
                                Aclaraciones
                            </CardTitle>
                            <CardSubtitle
                                className="mb-2 text-muted"
                                tag="h5"
                                style={{ textAlign: "center" }}
                            >
                                REUNE
                            </CardSubtitle>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </section>
    );

};

export default PanelReune;